import { PaymentMethod } from '../models/Organization';

/** Used only when the tutor payload omits the field (legacy / incomplete responses). */
export const DEFAULT_TUTOR_PAYMENT_METHODS: PaymentMethod[] = [
  PaymentMethod.CASH,
  PaymentMethod.ONLINE,
];

/**
 * Tutor checkout must use tutor response `supportedPaymentMethods` (org tutor list),
 * never room / organization room `supportedPaymentMethods`.
 */
export function resolveTutorBookingPaymentMethods(
  supportedPaymentMethods: PaymentMethod[] | null | undefined,
): PaymentMethod[] {
  if (supportedPaymentMethods != null) {
    return supportedPaymentMethods;
  }
  return DEFAULT_TUTOR_PAYMENT_METHODS;
}
